import { 
  Form, 
  Input, 
  Button, 
  Select,
  Result,
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { signularisApi, useCreateMetaDocumentMutation, useGetRecipientsListQuery } from "../../../store/api/signularisApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useAppDispatch } from "../../../hooks/redux";
import genDocument4 from '../misc/gendoc4';
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import style from '../CreateDocument.module.scss';
import { SendOutlined, CarOutlined, UserOutlined, EnvironmentOutlined } from "@ant-design/icons";

const { Item } = Form;
const { Option } = Select;

let guid = () => {
  let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
  return s4() + s4() + s4() + s4();
}

function styledDate() {
  const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", 
                  "августа", "сентября", "октября", "ноября", "декабря"]
  const dobj = new Date()
  return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

function Template() {
  const info = useSelector((state: RootState) => state.userinfo)
  const dispatch = useAppDispatch()
  const { data: recipientsList } = useGetRecipientsListQuery()
  const [docname, setDocname] = useState("")
  const docTemplate : DocTemplateType = 'passToGGNTU'

  const [createMetaDocument, {
    isLoading: mutationLoading, 
    isSuccess: mutationSuccess,
  } ] = useCreateMetaDocumentMutation()

  const [form] = useForm()

  const onFinish = async (values: any) => {
    const regnum = guid()
    setDocname('Заявка на пропуск')
    const formData = new FormData()
    formData.append("title", `Заявка на пропуск №${regnum}`)
    formData.append("brief", "Сгенерировано из шаблона")
    formData.append("recipients", values.recipients.join(","))
    formData.append("documentType", docTemplate)

    const templateValues = {
        ...values,
        regnum,
        dutyface: `${info.lastname} ${info.firstname} ${info.middlename}`
    }
    
    const pdfBytes = await genDocument4(templateValues, info)
    formData.append("file", new Blob([pdfBytes]))
    createMetaDocument(formData)
    dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
  }

  if (mutationSuccess) {
    return (
      <Result
        status="success"
        title="Заявка создана"
        subTitle={`Пропуск на имя ${form.getFieldValue('guest_fullname')} успешно оформлен.`}
        extra={[
          <Link key="back" to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}>
            <Button type="primary">Создать еще</Button>
          </Link>
        ]}
      />
    )
  }

  return (
    <div className={style.generatorWrapper}>
      <h2 className={style.title}>Заявка на пропуск в ГГНТУ</h2>
      
      <Form 
        form={form} 
        onFinish={onFinish} 
        layout="vertical"
        initialValues={{date: styledDate()}}
      >
        <Item label="Получатели" name="recipients" rules={[{ required: true, message: 'Выберите получателей' }]}>
          <Select
            mode="multiple"
            allowClear
            placeholder="Выберите сотрудников..."
            size="large"
          >
             {recipientsList?.map((recipient) => (
                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                  {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                </Option>
            ))}
          </Select>
        </Item>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: 10 }}>
            <Item label="Корпус" name="corpus" rules={[{ required: true }]}>
                <Input prefix={<EnvironmentOutlined style={{color: '#94a3b8'}} />} placeholder="Напр: 1 корпус"/>
            </Item>
            <Item label="Дата и время" name="date" rules={[{ required: true }]}>
                <Input placeholder="01.01.2024 10:00"/>
            </Item>
        </div>

        <h3 style={{ fontSize: 14, fontWeight: 700, margin: '16px 0', color: '#475569' }}>Информация о госте</h3>
        
        <Item label="ФИО / Должность гостя" name="guest_fullname" rules={[{ required: true }]}>
          <Input prefix={<UserOutlined style={{color: '#94a3b8'}} />} placeholder="Иванов Иван Иванович"/>
        </Item>

        <Item label="Кто принимает " name="recv_fullname" rules={[{ required: true }]}>
          <Input placeholder="Укажите сотрудника"/>
        </Item>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <Item label="ФИО / Должность отправителя" name="send_fullname" rules={[{ required: true }]}>
                <Input placeholder="Ваше ФИО"/>
            </Item>
            <Item label="Телефон отправителя" name="send_phone" rules={[{ required: true }]}>
                <Input placeholder="+7 (___) ___ __ __"/>
            </Item>
        </div>

        <Item label="Автомобиль (номер/марка)" name="auto" rules={[{ required: true }]}>
          <Input prefix={<CarOutlined style={{color: '#94a3b8'}} />} placeholder="А001АА 95 / Toyota Camry (если требуется)"/>
        </Item>

        <Button 
            type="primary" 
            htmlType="submit" 
            loading={mutationLoading}
            size="large"
            icon={<SendOutlined />}
            style={{ width: '100%', marginTop: '20px' }}
        >
            Создать заявку
        </Button>
      </Form>
    </div>
  )
}

export default Template;
